import 'vue-datetime/dist/vue-datetime.css';
import './styles.scss';

import Vue from 'vue';
import vuetify from './plugins/vuetify';
import { Plugin } from 'vue-fragment';
import Notifications from 'vue-notification'

import Datetime from 'vue-datetime';

import { Settings } from 'luxon';

import Chart from 'chart.js';
import moment from 'moment';
import App from './App';
import router from './router';
import store from './store';
import AdminOnly from './components/common/AdminOnly.vue';
import '@/timeparkApi/apiClient';

Chart.defaults.global.defaultFontSize = 18;

Settings.defaultLocale = 'de';
moment.locale('de');
Vue.component('admin-only', AdminOnly);
Vue.use(Plugin);
Vue.use(Notifications);

Vue.use(Datetime);

/* eslint-disable no-new */

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
